import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";
import TeacherDashboardReducer from "./TeacherDashboard/reducer";
//DashBoard
import DashReducer from "./Dashboard/reducer";
import NotificationReducer from "./Notifications/reducer";
import FeedBackReducer from "./FeedBack/reducer";
import SchoolInfoReducer from "./GetSchoolInfo/reducer";
import TimeTableReducer from "./TimeTable/reducer";
import FeesReducer from "./Fees/reducer";
import CommonReducer from "./Common/Reducer";
import AttendanceReducer from "./Attendance/reducer";
import GallaryReducer from "./Gallary/reducer";
import SubjectRequest from "./SubjectRequest/subjectSlice";

import ClassWorkReducer from "./ClassWork/Reducer";
import TransportReducer from "./Transport/reducer";
// New NOTIFICATION Center
import ClassTestReducer from "./TeacherApp/Exam/Reducer";
import GatePassReducer from "./gatePass/reducers";
const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
 ClassTestReducer,
  DashReducer,
  NotificationReducer,
  FeedBackReducer,
  SchoolInfoReducer,
  TimeTableReducer,
  FeesReducer,
  CommonReducer,
  AttendanceReducer,
  GallaryReducer,
  SubjectRequest,
  ClassWorkReducer,
  TransportReducer,
  GatePassReducer,
  TeacherDashboardReducer
});

export default rootReducer;
